import { Injector } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { SmsCreditSubscriptionStateService } from '../services/sms-credit-subscription-state.service';

export function dateNotInThePastValidator(
  control: AbstractControl,
): Record<string, unknown> | null {
  if (control?.value) {
    const { day, month, year } = control?.value;
    const d1 = new Date(year, month - 1, day).getTime();
    const d2 = new Date().setHours(0, 0, 0, 0);
    return d1 < d2 ? { wrongDate: true } : null;
  }
  return null;
}

export function renewalDateForSubscriptionChnageValidator(injector: Injector) {
  return (control: AbstractControl): Record<string, unknown> | null => {
    const subscriptionChangeEffectiveDate = injector.get(
      SmsCreditSubscriptionStateService,
    ).subscriptionChangeEffectiveDateSubject$.value;
    if (control?.value && subscriptionChangeEffectiveDate) {
      const { day, month, year } = control?.value;
      const d1 = new Date(year, month - 1, day).getTime();
      const d2 = new Date().setHours(0, 0, 0, 0);
      const d3 = new Date(subscriptionChangeEffectiveDate).setHours(0, 0, 0, 0);
      return d1 <= d2 || d1 < d3 ? { wrongDate: true } : null;
    }
    return null;
  };
}

export function renewalDateForUpcomingSubscriptionValidator(
  injector: Injector,
) {
  return (control: AbstractControl): Record<string, unknown> | null => {
    const upcomingSubscriptionEffectiveDate = injector.get(
      SmsCreditSubscriptionStateService,
    ).upcomingSubscriptionEffectiveDateSubject$.value;
    if (control?.value) {
      const { day, month, year } = control?.value;
      const d1 = new Date(year, month - 1, day).getTime();
      const d2 = new Date().setHours(0, 0, 0, 0);
      const d3 = new Date(upcomingSubscriptionEffectiveDate).setHours(
        0,
        0,
        0,
        0,
      );
      return d1 <= d2 || (upcomingSubscriptionEffectiveDate && d1 <= d3)
        ? { wrongDate: true }
        : null;
    }
    return null;
  };
}

export function changeSubscriptionEffectiveDateValidator(injector: Injector) {
  return (control: AbstractControl): Record<string, unknown> | null => {
    const upcomingSubscriptionEffectiveDate = injector.get(
      SmsCreditSubscriptionStateService,
    ).upcomingSubscriptionEffectiveDateSubject$.value;
    if (control?.value) {
      const { day, month, year } = control?.value;
      const d1 = new Date(year, month - 1, day).getTime();
      const d2 = new Date().setHours(0, 0, 0, 0);
      const d3 = new Date(upcomingSubscriptionEffectiveDate).setHours(
        0,
        0,
        0,
        0,
      );
      return d1 <= d2 || (upcomingSubscriptionEffectiveDate && d1 > d3)
        ? { wrongDate: true }
        : null;
    }
    return null;
  };
}

export function changeSubscriptionCreditsValidator(injector: Injector) {
  return (control: AbstractControl): Record<string, unknown> | null => {
    const currentSubscriptionCredits = injector.get(
      SmsCreditSubscriptionStateService,
    ).currentSubscriptionCreditsSubject$.value;

    if (control?.value) {
      const pattern = /^[0-9]+$/;
      return pattern.test(control.value) &&
        Number(control.value) > currentSubscriptionCredits
        ? null
        : { wrongSubscriptionCredits: true };
    }
    return null;
  };
}

export function topUpCreditsValidator(
  control: AbstractControl,
): Record<string, unknown> | null {
  if (control?.value) {
    const pattern = /^[0-9]+$/;
    return pattern.test(control.value) && Number(control.value) > 0
      ? null
      : { wrongTopUpCredits: true };
  }
  return null;
}

export function topUpEffectiveDateValidator(
  control: AbstractControl,
): Record<string, unknown> | null {
  if (control?.value) {
    const { day, month, year } = control?.value;
    const d1 = new Date(year, month - 1, day).getTime();
    const d2 = new Date().setHours(0, 0, 0, 0);
    return d1 < d2 ? { wrongTopUpEffectiveDate: true } : null;
  }
  return null;
}

export function topUpExpirationDateValidator(
  topUpEffectiveDateFieldName: string,
) {
  return (control: AbstractControl): Record<string, unknown> | null => {
    const topUpEffectiveDateControl = control.parent?.get(
      topUpEffectiveDateFieldName,
    );
    if (control?.value && topUpEffectiveDateControl?.value) {
      const { day: expDay, month: expMonth, year: expYear } = control?.value;
      const expirationDate = new Date(expYear, expMonth - 1, expDay).getTime();
      const {
        day: effDay,
        month: effMonth,
        year: effYear,
      } = topUpEffectiveDateControl.value;
      const effectiveDate = new Date(effYear, effMonth - 1, effDay).getTime();
      return expirationDate <= effectiveDate
        ? { wrongTopUpExpirationDate: true }
        : null;
    }
    if (!topUpEffectiveDateControl?.value && control?.value) {
      return { wrongTopUpEffectiveDate: true };
    }
    return null;
  };
}

export function orderNumberValidator(
  control: AbstractControl,
): Record<string, unknown> | null {
  if (control?.value) {
    const pattern = /^[A-Za-z0-9]{16}$/;
    return pattern.test(control.value) ? null : { wrongOrderNumber: true };
  }
  return null;
}
